
import request from "@/request/request";


// 登录方法请求
export function contactus(data) {
  return request({
    url: "/admin/website/contactus",
    method: "post",
    data: data,
  });
}
// 链接地址
export function getClientList(data) {
  return request({
    url: "/api/codeorder/getClientList",
    method: "post",
    data: data,
  });
}





